module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av425-f6487aa2a4ab1b365870f5bf83874935.jpg";